export default __webpack_public_path__ + "assets/fda489e19b8681b75ff2d7b3590117c6.png";